<template>
    <Dialog :dialogVisible.sync='showDialog' title='请选择沟通联系人'  @close='closedialog'>
        <el-table :data="tableData" size="small" style="width: 100%"
            :header-cell-style="{background:'#F7F7F7',fontWeight:'normal',fontSize:'13px',}"
            :cell-style="{fontSize:'14px'}">
            <el-table-column align="center" prop="realName" label="姓名"></el-table-column>
            <el-table-column align="center" prop="department" label="部门" width="120"></el-table-column>
            <el-table-column align="center" prop="post" label="职务" width="120"></el-table-column>
            <el-table-column align="center" prop="status" label="在线状态" width="80"></el-table-column>
            <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="go_chat(scope.row)">沟通</el-button>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer"></span>
    </Dialog>
</template>

<script>
import {enterpriseUser} from '@/api/common'
    export default {
        name:'',
        props:['dialogVisible','chatUserObj'],
        data () {
            return {
                showDialog:false,
                tableData:[],
            }
        },
        components: {},
        computed: {},
        beforeMount() {},
        mounted() {
            this.get_list()
            console.log(this.chatUserObj)
        },
        methods: {
            get_list(){
                enterpriseUser({
                    enterpriseId:this.chatUserObj.enterpriseId
                }).then(res=>{
                    if(res.data.length==0){
                        this.$message.warning('该企业暂无联系人!')
                        this.closedialog()
                    }else if(res.data.length >1){
                        this.showDialog = true
                        this.tableData = res.data
                    }else if(res.data.length ==1){
                        this.$gfn.checkPerm(this.chatUserObj.perms).then(ress=>{
                            if(ress){
                                window.open(this.$redirectUrl.jumpClient() + `/chat?userId=${res.data[0].id}&chatType=${this.chatUserObj.chatType}&itemId=${this.chatUserObj.itemId}`, '_blank')
                            }else{
                                this.$router.push({path:'/403'})
                            }
                        })
                        this.closedialog()
                    }
                })
            },
            go_chat(row){
                this.$gfn.checkPerm(this.chatUserObj.perms).then(res=>{
                    if(res){
                        window.open(this.$redirectUrl.jumpClient() + `/chat?userId=${row.id}&chatType=${this.chatUserObj.chatType}&itemId=${this.chatUserObj.itemId}`, '_blank')
                    }else{
                        this.$router.push({path:'/403'})
                    }
                })
            },
            closedialog(){
                this.$emit('close')
            },
        },
    }

</script>

<style lang='scss' scoped>

</style>